// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6730e33c","455":"79f2eceb","977":"d77c83c7"}[chunkId] + ".chunk.js";
};